/**
 * Saved Views API Client
 *
 * Manage saved filter view snapshots with pinning for bookmarks bar.
 */

import apiClient from './client';

export interface SavedView {
  id: string;
  name: string;
  viewType: 'tasks' | 'templates' | 'kanban' | 'calendar' | 'search';
  filterConfig: Record<string, any>;
  sortConfig: Record<string, any> | null;
  isPinned: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSavedView {
  name: string;
  view_type: 'tasks' | 'templates' | 'kanban' | 'calendar' | 'search';
  filter_config: Record<string, any>;
  sort_config?: Record<string, any>;
  is_pinned?: boolean;
}

export interface UpdateSavedView {
  name?: string;
  filter_config?: Record<string, any>;
  sort_config?: Record<string, any> | null;
}

export const savedViewsApi = {
  async list(pinnedOnly = false): Promise<SavedView[]> {
    const params = pinnedOnly ? '?pinned=true' : '';
    const response = await apiClient.get(`/v1/saved-views${params}`);
    return response.data;
  },

  async create(data: CreateSavedView): Promise<SavedView> {
    const response = await apiClient.post('/v1/saved-views', data);
    return response.data;
  },

  async update(id: string, data: UpdateSavedView): Promise<void> {
    await apiClient.put(`/v1/saved-views/${id}`, data);
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/v1/saved-views/${id}`);
  },

  async togglePin(id: string): Promise<{ isPinned: boolean; sortOrder: number }> {
    const response = await apiClient.post(`/v1/saved-views/${id}/pin`);
    return response.data;
  },

  async reorder(viewIds: string[]): Promise<void> {
    await apiClient.post('/v1/saved-views/reorder', { view_ids: viewIds });
  },
};
